import React, { FC, useEffect } from 'react';
import ShippingCountryWrapper from './ShippingCountryWrapper';
import GlobeImg from './GlobeImg';
import BorderArrowUp from './BorderArrowUp';
import ChangeShipping from '../../ChangeShipping/ChangeShipping';
import ChangeShippingCountryWrapper from './ChangeShippingCountryWrapper';
import { Desktop } from '../../MediaQuery';
import { useAppContext } from '../../../store/appContext';
import { useUrlBuilder } from '../../../hooks/useUrlBuilder';

interface ShippingCountryProps {
  changeShippingVisibility: () => void;
  isShippingSelectorVisible: boolean;
}

const ShippingCountry: FC<ShippingCountryProps> = ({ changeShippingVisibility, isShippingSelectorVisible }) => {
  const labelGlobeRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();
  const changeShippingRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

  const { countryIso } = useAppContext();
  const { withCDN } = useUrlBuilder();

  const handleClickOutside = event => {
    const clickOutsidePopup =
      changeShippingRef && changeShippingRef.current && !changeShippingRef.current.contains(event.target);
    const clickOutsideCountryGLobe =
      labelGlobeRef && labelGlobeRef.current && !labelGlobeRef.current.contains(event.target);

    if (clickOutsidePopup && clickOutsideCountryGLobe) {
      changeShippingVisibility();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const handleChangeShippingVisible = () => {
    // if (!isChangeShippingCountryVisible) {
    changeShippingVisibility();
  };

  return (
    <div style={{ position: 'relative' }}>
      <Desktop>
        <ShippingCountryWrapper
          ref={labelGlobeRef}
          data-cy="header-shipping-country-label"
          onClick={handleChangeShippingVisible}
        >
          <span style={{ color: '#999', fontSize: '15px', marginRight: '5px' }}>{countryIso.toUpperCase()}</span>
          <GlobeImg data-cy="image-search-open" src={withCDN('mkt/header/globe.svg')} />
        </ShippingCountryWrapper>
      </Desktop>
      {isShippingSelectorVisible && (
        <>
          <Desktop>
            <div
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                height: '100%',
                left: 0,
                position: 'fixed',
                top: 0,
                width: '100%',
                zIndex: 5,
              }}
            />
          </Desktop>
          <ChangeShippingCountryWrapper ref={changeShippingRef}>
            <Desktop>
              <BorderArrowUp />
            </Desktop>
            <ChangeShipping changeShippingVisibility={changeShippingVisibility} />
          </ChangeShippingCountryWrapper>
        </>
      )}
    </div>
  );
};

export default ShippingCountry;
